module.exports = __webpack_public_path__ + "static/img/DE@2x.d8678664.jpg";